import { ChangeEventHandler, useRef, useState } from 'react';
import { useNavigation } from '@/navigation/NavigationContex.ts';
import { validateGrid } from '@/components/slides/GridScanner/validateGrid.ts';
import { extractGrid } from '@/components/slides/GridScanner/extractGrid.ts';
import { isSuperGrid } from '@/util/isSuperGrid.ts';
import { useForm } from '@/form/useForm.ts';
import { useLayer } from '@/layers/useLayer.tsx';

export const useScanner = () => {
  const { currentSlide } = useNavigation();
  const prefix = currentSlide!.prefix!;

  const { onChange } = useForm();
  const { setSlideValid, skipToNext } = useNavigation();

  const inputRef = useRef<HTMLInputElement | null>(null);
  const [gridValue, setGridValue] = useState<string>('');
  const [isGridValid, setIsGridValid] = useState<boolean>(false);

  const { showLayer } = useLayer();

  const onInputChange: ChangeEventHandler<HTMLInputElement> = (e) => {
    const newValue = e.target.value.substring(e.target.value.length - 12);
    setGridValue(newValue);
    const [_, gridValue] = extractGrid(newValue, prefix);
    const gridId = `${prefix}${gridValue}`;
    const isValid = validateGrid(gridId, prefix);
    setIsGridValid(isValid);

    if (isSuperGrid(newValue)) {
      handleValidGrid(newValue);
    }

    if (gridValue.length >= 12) {
      if (!isValid) {
        showLayer({ ref: '@invalidGridHint' });
      } else {
        handleValidGrid(gridId);
      }
    }
  };

  const onScannerChange = (result: string) => {
    const [_, gridValue] = extractGrid(result, prefix);
    const gridId = `${prefix}${gridValue}`;
    const isValid = validateGrid(gridId, prefix);
    setIsGridValid(isValid);
    setGridValue(gridValue);

    if (isValid) {
      handleValidGrid(gridId);
    }
  };

  const handleValidGrid = (gridId: string) => {
    // Store it in formData
    const data = {
      raw: gridId,
      normalized: gridId,
    };
    onChange('donorId', { value: data, isValid: true, slideId: currentSlide!.id, hint: undefined });

    // Go to the next slide. No point in dilly-dallying.
    setTimeout(skipToNext, 100);
  };

  const reset = () => {
    setGridValue('');
    setIsGridValid(false);
    setSlideValid(false);
  };

  return {
    reset,
    inputRef,
    gridValue,
    onInputChange,
    isGridValid,
    onScannerChange,
  };
};
